import {
  CLIENT_ID,
  getIsAzure,
  HZA_IFRAME_URL,
  TENANT_ID,
} from "./auth/authConfig";
async function bootApp() {
  if (!navigator.cookieEnabled) {
    return require("./roots/disabledCookies.js");
  }

  const loginType = await getIsAzure();
  if (loginType.data.azure) {
    const { clientId, tenantId, hzaIframeURL } = loginType.data;
    if (clientId && tenantId) {
      localStorage.setItem(CLIENT_ID, clientId);
      localStorage.setItem(TENANT_ID, tenantId);
      localStorage.setItem(HZA_IFRAME_URL, hzaIframeURL);
      return require("./roots/msalRoot.js");
    }
  }
}

bootApp();
